var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomLeftQuarterCircleOfGate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 32C27.7977 32 23.6365 31.1723 19.7541 29.5641C15.8717 27.956 12.3441 25.5989 9.37258 22.6274C6.40111 19.6559 4.044 16.1283 2.43585 12.2459C0.827704 8.36345 -3.67377e-07 4.2023 0 -1.90735e-06L32 0L32 32Z",
    fill: "#A90821"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomLeftQuarterCircleOfGate);
export default __webpack_public_path__ + "static/media/BottomLeftQuarterCircleOfGate.d60fdf72.svg";
export { ForwardRef as ReactComponent };